import styled from 'styled-components'

const Div = styled.div`
  color: ${({ theme }) => theme.titles};
  padding-top: 32px;
`

export { Div }
